import { Button, Card, Text, Badge } from '@/ui'
import {
  getFreeTrialEndsAt,
  selectFreeTrialLengthDays,
  selectIsInFreeTrial2026,
} from '@/selectors/user.selectors'
import { DATE_FORMATS_LUXON } from '@/utils/dateHelpers'
import { useReselector } from '@/utils/sharedHooks'
import { TypographyStyles } from '@/styles'
import { DateTime } from 'luxon'

/** Drew's booking page for the freetrial2026 sales assist. */
const FREE_TRIAL_CONSULT_URL =
  'https://meetings.hubspot.com/drew-milton/free-trial-meeting'

const FreeTrialBanner = () => {
  const trialEndsAt = useReselector(getFreeTrialEndsAt)
  const trialLength = useReselector(selectFreeTrialLengthDays)
  const isFreeTrial2026 = useReselector(selectIsInFreeTrial2026)

  return (
    <Card>
      {trialLength ? (
        <Badge color="orange" variant="secondary" size="sm" className="mb-4">
          {trialLength}-DAY FREE TRIAL
        </Badge>
      ) : null}
      <Text as={TypographyStyles.BODY_SM}>
        Your trial ends on{' '}
        {trialEndsAt
          ? DateTime.fromISO(trialEndsAt).toFormat(
              DATE_FORMATS_LUXON.DISPLAY_SIMPLE
            )
          : ''}
      </Text>
      {isFreeTrial2026 && (
        // Two stacked lines, so the button overrides the atom's single-line sizing:
        // auto height, column layout, and wrapping instead of `whitespace-nowrap`.
        <Button
          asChild
          variant="secondary"
          size="sm"
          className="mt-4 h-auto w-full flex-col gap-0 whitespace-normal py-2 leading-tight"
        >
          <a
            href={FREE_TRIAL_CONSULT_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="block">Make the most of your trial.</span>
            <span className="block">Book a consult</span>
          </a>
        </Button>
      )}
    </Card>
  )
}

export default FreeTrialBanner
